import Request from "../Request.js";

const FFSOLAR_SERVER_URL = window.runtimeConfig?.FFSOLAR_SERVER_URL;
const annotations = {
  getAnnotations(projectId) {
    return Request.get(`${FFSOLAR_SERVER_URL}/projects/${projectId}/annotations`);
  },
  analyzeAnnotation(projectId, imageBase64, language) {
    return Request.post(`${FFSOLAR_SERVER_URL}/annotations/prediction`, {
      project_id: Number(projectId),
      imageBase64: imageBase64,
      language: language || 'de',
    });
  },
  deleteAnnotation(annotationId) {
    return Request.delete(`${FFSOLAR_SERVER_URL}/annotations/${annotationId}`);
  },
  saveAnnotation(projectId, imagePk, data) {
    return Request.post(`${FFSOLAR_SERVER_URL}/annotations`, {
      project_id: Number(projectId),
      image_id: imagePk,
      damage_type: data.damageType,
      severity_level: data.severityLevel,
      description: data.description,
      recommended_action: data.recommendedAction,
      predicted_type: data.predictedType,
      predicted_severity_level: data.predictedSeverityLevel,
      predicted_description: data.predictedDescription,
      predicted_recommended_actions: data.predictedRecommendedActions,
      x: data.imgX,
      y: data.imgY,
      width: data.imgWidth,
      height: data.imgHeight,
      norm_x: data.normX,
      norm_y: data.normY,
      image_index: data.imageIndex,
      frame_image: data.cropImageUrl,
    });
  },
  updateAnnotation(annotationId, projectId, imagePk, data) {
    return Request.put(`${FFSOLAR_SERVER_URL}/annotations`, {
      id: annotationId,
      project_id: Number(projectId),
      image_id: imagePk,
      damage_type: data.damageType,
      severity_level: data.severityLevel,
      description: data.description,
      recommended_action: data.recommendedAction,
      predicted_type: data.predictedType,
      predicted_severity_level: data.predictedSeverityLevel,
      predicted_description: data.predictedDescription,
      predicted_recommended_actions: data.predictedRecommendedActions,
      x: data.imgX,
      y: data.imgY,
      width: data.imgWidth,
      height: data.imgHeight,
      norm_x: data.normX,
      norm_y: data.normY,
      image_index: data.imageIndex,
      frame_image: data.cropImageUrl,
    });
  },
};

export default annotations;

export const uploadCropImage = (projectId, imageBase64) =>
  Request.post(`${window.runtimeConfig.FFSOLAR_SERVER_URL}/annotations/crop-image`, {
    project_id: projectId,
    image_base64: imageBase64,
  });

export const getCustomDamageTypes = () =>
  Request.get(`${window.runtimeConfig.FFSOLAR_SERVER_URL}/user-preferences/custom-damage-types`);

export const addCustomDamageType = (damageType) =>
  Request.post(`${window.runtimeConfig.FFSOLAR_SERVER_URL}/user-preferences/custom-damage-types`, {
    damage_type: damageType,
  });
